export class LoginModel {
  id: number | null = null;
  token: string | null = null;
  username: string | null = null;
  firstName: string | null = null;
  lastName: string | null = null;
  role: string | null = null;
}

export class LoginDto {
  username = "";
  password = "";
}